import './not-found.css';

function NotFound() {
    function handleBack() {
        window.location.href = '/';
    }

    return (
        <section className='not-found'>
            <div className='not-found__card'>
                <p className='not-found__tag'>Bertoli Tours Admin</p>
                <h1>Página não encontrada</h1>
                <p>
                    O endereço que você tentou acessar não existe ou foi movido. Confira a URL e tente novamente.
                </p>

                <div className='not-found__actions'>
                    <button className='blue-button' type='button' onClick={handleBack}>
                        Voltar ao início
                    </button>
                </div>
            </div>
        </section>
    );
}

export default NotFound;
